import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "screen:space-y-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-medium" }, "Valgte helbredssegmenter", -1)
const _hoisted_3 = { class: "bg-white rounded-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericTable = _resolveComponent("GenericTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_GenericTable, {
        headers: _ctx.headers,
        options: { rowHeight: 60 },
        items: _ctx.items,
        "pinned-bottom-row-data": _ctx.pinnedBottomRowData
      }, null, 8, ["headers", "items", "pinned-bottom-row-data"])
    ])
  ]))
}